import axios from 'axios';
export const getCsrfToken = async (basePath) => {
    const url = [basePath, 'vapp/auth/csrf'].join('/');
    const response = await axios.get(url, {
        withCredentials: true,
    });
    return response.data?.token;
};
